<template>
  <nav id="topnav" class="navbar is-dark" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link to="/" class="navbar-item">
        <span class="navbar-logo"> Mindsight.io</span>
      </router-link>

      <a role="button" class="navbar-burger" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': showNav }">
      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <img v-if="loggedInUser" :src="loggedInUser.picture"/>
          </a>

          <div class="navbar-dropdown">
            <router-link to="/settings/" class="navbar-item">
              <p>Settings</p>
            </router-link>

            <router-link to="/" class="navbar-item">
              <p @click="logUserOut">Log Out</p>
            </router-link>
          </div>
        </div>

        <div class="navbar-item">
          <p id="username" v-if="loggedInUser">{{ loggedInUser.name }} ({{ loggedInUser.org.name }})</p>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { gql } from "apollo-boost";

export default {
  name: "TopNav",
  apollo: {
    loggedInUser: gql`
      {
        loggedInUser {
          name
          nickname
          picture
          org {
            name
          }
        }
      }
    `
  },
  data() {
    return {
      loggedInUser: null,
      showNav: false
    };
  },
  methods: {
    logUserOut() {
      this.$auth0.logout();
    }
  }
};
</script>

<style>
#topnav {
  /* background-color: #334a5f; */
}

#username {
  color: #f1f1f1;
}

a {
  color: #0091d5;
  cursor: pointer;
  text-decoration: none;
}

.navbar-link::after {
  border-color: #0091d5;
  margin-top: -0.375em;
  right: 1.125em;
}

.navbar-logo {
  font-weight: 700;
}
</style>
